import { SimpleDateRangeFilter as AntdSimpleDateRangeFilter } from "@empglabs/backoffice-ui-kit"

const SimpleDateRangeFilter = props => {
  return <AntdSimpleDateRangeFilter {...props} />
}

export default SimpleDateRangeFilter
